/**
 * ذخیره‌سازی انتخابی و debounce شده‌ی state در localStorage.
 *
 * نسخه‌ی قبلی با هر mutation کل state (شامل لیست تیکت‌ها، داشبورد و ...) را
 * JSON.stringify و ذخیره می‌کرد که روی دستگاه ضعیف باعث کندی می‌شد.
 * اینجا فقط بخش‌های لازم برای بازیابی نشست ذخیره می‌شوند و نوشتن debounce دارد.
 *
 * احراز هویت اکنون با کوکی HttpOnly است؛ توکن‌ها هرگز در localStorage ذخیره
 * نمی‌شوند (در pick() از شیء user پاک می‌شوند). فقط اطلاعات نمایشی نشست ذخیره
 * می‌شود و اعتبار واقعی نشست هنگام bootstrap با account/Session بررسی می‌شود.
 */

const PERSIST_KEYS = [
    "user",
    "userProfile",
    "signedIn",
    "config",
    "notificationToken",
    "sidenav",
];

export function loadPersistedState(storageKey) {
    try {
        const raw = localStorage.getItem(storageKey);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === "object" ? parsed : null;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error("loadPersistedState:", e && e.message);
        return null;
    }
}

function pick(state) {
    const out = {};
    for (const k of PERSIST_KEYS) {
        if (Object.prototype.hasOwnProperty.call(state, k)) out[k] = state[k];
    }
    // توکن‌ها هرگز روی دیسک نروند — احراز هویت با کوکی HttpOnly است.
    if (out.user && typeof out.user === "object") {
        out.user = { ...out.user, AccessToken: null, RefreshToken: null };
    }
    return out;
}

export function clearPersistedState(storageKey) {
    try {
        localStorage.removeItem(storageKey);
    } catch (e) {
        /* noop */
    }
}

/** یک تابع ذخیره‌ی debounce شده می‌سازد. */
export function createPersister(storageKey, wait = 400) {
    let timer = null;
    let pending = null;

    const flush = () => {
        timer = null;
        if (!pending) return;
        try {
            localStorage.setItem(storageKey, JSON.stringify(pick(pending)));
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error("persistState:", e && e.message);
        }
        pending = null;
    };

    return function persist(state) {
        pending = state;
        if (timer) return;
        timer = setTimeout(flush, wait);
    };
}

export default { loadPersistedState, clearPersistedState, createPersister, PERSIST_KEYS };
